/* eslint-disable camelcase */
import { LocaleMessages } from 'vue-i18n';

const elementLang_en = require('element-ui/lib/locale/lang/en').default;
const elementLang_zh_TW = require('element-ui/lib/locale/lang/zh-TW').default;
const elementLang_zh_CN = require('element-ui/lib/locale/lang/zh-CN').default;
const elementLang_vi = require('element-ui/lib/locale/lang/vi').default;
const elementLang_th = require('element-ui/lib/locale/lang/th').default;


/** 設定element的語言，若無該語言，就回退英文 */
const setElementLang = (msg: LocaleMessages): LocaleMessages => {
  const result = msg;
  /** 取出message成品的所有語言 */
  const allLocales = Object.keys(result);
  /** require需要的element語言檔案 */
  allLocales.forEach((locale: string) => {
    /** 成品有該語言就concat 沒有就放英文 */
    switch (locale) {
      case 'zh_TW':
        Object.assign(result.zh_TW, elementLang_zh_TW);
        break;
      case 'zh_CN':
        Object.assign(result.zh_CN, elementLang_zh_CN);
        break;
      case 'VN':
        Object.assign(result.VN, elementLang_vi);
        break;
      case 'TH':
        Object.assign(result.TH, elementLang_th);
        break;
      default:
        Object.assign(result[locale], elementLang_en);
        break;
    }
  });
  return result;
};

export default setElementLang;
